import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Input } from '../../../../../components/ui/input';
import { Button } from '../../../../../components/ui/button';

interface NewFolderModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  newFolderName: string;
  setNewFolderName: (name: string) => void;
  handleCreateFolder: () => void;
}

const NewFolderModal: React.FC<NewFolderModalProps> = ({
  isOpen,
  onOpenChange,
  newFolderName,
  setNewFolderName,
  handleCreateFolder,
}) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50" />
        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-background text-text-primary p-6 rounded-lg shadow-lg w-[400px]">
          <Dialog.Title className="text-lg font-medium mb-4 text-primary">
            Create New Folder
          </Dialog.Title>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium  mb-1">
                Folder Name
              </label>
              <Input
                type="text"
                placeholder="Enter folder name"
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
              />
            </div>
            <div className="flex justify-end gap-2">
              <Button
                variant="customSecondary"
                className="bg-secondary"
                onClick={() => onOpenChange(false)}
              >
                Cancel
              </Button>
              <Button
                variant="customSecondary"
                className="bg-secondary"
                onClick={handleCreateFolder}
              >
                Create
              </Button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default NewFolderModal;
